<template>
    <div>
        <Main title="Activations History" subtitle="Overall Activations">
            <template v-slot:table>
                <v-app>
                    <div class="row mb-1">
                        <div class="col-md-4 align-self-center">
                            <div class="input-group">
                                <v-text-field
                                    v-model="search.q"
                                    clearable
                                    clear-icon="mdi-close"
                                    type="text"
                                    placeholder="Search by activation name or ID"
                                >
                                </v-text-field>
                            </div>
                        </div>
                        <div class="col-md-3 align-self-center">
                            <div class="row">
                                <div class="col-6 text-center mb-6">
<!--                                    <v-tooltip color="primary">-->
<!--                                        <template v-slot:activator="{ on, attrs }">-->
<!--                                        <div-->
<!--                                                v-bind="attrs"-->
<!--                                                v-on="on"-->
<!--                                        >-->
<!--                                            <span class="info-label d-block mb-1 font-lg text-uppercase">EIDs</span>-->
<!--                                            <span class="info-data p-2">{{ new Intl.NumberFormat().format(totals.eids) }}</span>-->
<!--                                        </div>-->
<!--                                        </template>-->
<!--                                        <span>Total EIDs for the selected period.</span>-->
<!--                                    </v-tooltip>-->
                                </div>

                                <div class="col-6 text-center mb-6">
<!--                                    <v-tooltip color="primary">-->
<!--                                        <template v-slot:activator="{ on, attrs }">-->
<!--                                            <div-->
<!--                                                    v-bind="attrs"-->
<!--                                                    v-on="on"-->
<!--                                            >-->
<!--                                                <span class="info-label d-block mb-1 font-lg text-uppercase">Costs</span>-->
<!--                                                <span class="info-data p-2">${{ new Intl.NumberFormat().format(totals.price) }}</span>-->
<!--                                            </div>-->
<!--                                        </template>-->
<!--                                        <span>Total Costs ($)</span>-->
<!--                                    </v-tooltip>-->
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div class="form-inline">
                                <v-menu
                                    v-model="startDateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="search.startDate"
                                            label="Start Date"
                                            clearable
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        header-color="#fb7e42"
                                        color="#fb7e42"
                                        v-model="search.startDate"
                                        @input="startDateMenu = false"
                                        :max="search.endDate"
                                    ></v-date-picker>
                                </v-menu>
                                <span class="mx-2">to</span>
                                <v-menu
                                    v-model="endDateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="search.endDate"
                                            label="End Date"
                                            clearable
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        header-color="#fb7e42"
                                        color="#fb7e42"
                                        v-model="search.endDate"
                                        @input="endDateMenu = false"
                                        :min="search.startDate"
                                    ></v-date-picker>
                                </v-menu>
                                <button @click.prevent="fetchData" type="button" class="btn btn-light ml-2">
                                    <i class="fas fa-sync-alt"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-1 align-self-center">
                            <div class="btn-toolbar float-right" role="toolbar">
                                <button class="btn btn-light" type="button" data-toggle="modal" data-target=".filter-modal"><i class="fas fa-filter"></i></button>
                            </div><!--btn-toolbar-->
                        </div><!--col-->
                    </div>
                    <div class="modal fade filter-modal" tabindex="-1" role="dialog" aria-hidden="true">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Filter Activations</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <v-row class="mt-2">
                                        <v-col
                                            cols="12"
                                            md="3"
                                        >
                                            <v-select
                                                v-model="search.sortBy"
                                                :items="sorts"
                                                label="Sort By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="3"
                                        >
                                            <v-select
                                                v-model="search.orderBy"
                                                :items="orders"
                                                label="Order By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="3"
                                        >
                                            <v-select
                                                v-model="search.itemsPerPage"
                                                :items="perPage"
                                                label="Per Page"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="3"
                                        >
                                            <v-select
                                                v-model="search.createdBy"
                                                :items="$store.getters['getCreatedByItems']"
                                                label="Created By"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div class="modal-footer">
                                    <div class="col-md-2 col-2 px-0 text-right">
                                        <v-progress-circular
                                            v-if="search.loading"
                                            :width="2"
                                            :size="30"
                                            indeterminate
                                            color="#fb7e42"
                                            class="mr-2"
                                        ></v-progress-circular>

                                        <button type="button" class="btn btn-light" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">Close</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <TableLoading cols="10" v-if="loading"></TableLoading>
                    <div class="table-responsive mt-4" v-if="!loading">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">ID</span>
                                        </template>
                                        <span>Activation Identifier</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Activation Name</span>
                                        </template>
                                        <span>Activation Name</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">DataStreams</span>
                                        </template>
                                        <span>Activation Data Streams</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Endpoint</span>
                                        </template>
                                        <span>Activation endpoint</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Status</span>
                                        </template>
                                        <span>Activation Status (Processing, Completed)</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Analytics</span>
                                        </template>
                                        <span>Encrypted Identifiers count (Encrypted and Decrypted)</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Costs</span>
                                        </template>
                                        <span>Total Costs ($)</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Issued by</span>
                                        </template>
                                        <span>Activation was created by</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Updated at</span>
                                        </template>
                                        <span>Activation Updated at</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Created at</span>
                                        </template>
                                        <span>Activation Created at</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Actions</span>
                                        </template>
                                        <span>Activations Actions (Show, Remove)</span>
                                    </v-tooltip>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="activation in activations" :key="activation.id" class="activation-row">
                                <td>{{ activation.id || '' }}</td>
                                <td>
                                    <v-tooltip
                                        top
                                        color="primary"
                                        v-if="activation.scheduler"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">
                                                <i class="fas fa-sync-alt mr-1 text-info"></i>
                                            </span>
                                        </template>
                                        <span>Created by Scheduler</span>
                                    </v-tooltip>
                                    {{ activation.description || '' }}
                                </td>
                                <td>
                                    <ul class="list-unstyled" v-if="(activation.ds_results && activation.ds_results.length) || (activation.dataStreams && activation.dataStreams.length)">

                                        <li v-if="activation.ds_results && activation.ds_results.length" v-for="dataStream in activation.ds_results">
                                            <template v-if="dataStream.file">
                                                <a :href="dataStream.file.url" target="_blank" style="color: ${primaryColor};">
                                                    <i class="fas fa-external-link-alt mr-1"></i>
                                                </a>
                                            </template>
                                            <template v-else>
                                              <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                  <i v-bind="attrs" v-on="on" class="fas fa-exclamation-circle text-danger mr-1"></i>
                                                </template>
                                                <span>Not Available</span>
                                              </v-tooltip>
                                            </template>
                                            <span class="text-capitalize">{{ dataStream.name.replaceAll("_"," ") }}</span>
                                        </li>

                                        <li v-if="activation.dataStreams && (activation.ds_results && !activation.ds_results.length)" v-for="ds in activation.dataStreams">
                                            {{ ds }}
                                        </li>
                                    </ul>
                                </td>

                                <td>
                                    <span>{{ activation.endpoint.partner_name || 'Default' }}</span>
                                    <i v-if="activation.credentials !== null" class="fas fa-file orange-color" title="Credentials file attached."></i>
                                </td>
                                <td>
                                    <v-progress-linear
                                        v-if="!activation.isCompleted && !activation.status.isError"
                                        color="#fb7e42"
                                        height="10"
                                        indeterminate
                                        rounded
                                    ></v-progress-linear>

                                    <v-progress-linear
                                        v-if="activation.isCompleted"
                                        color="success"
                                        height="10"
                                        value="100"
                                        rounded
                                    ></v-progress-linear>

                                    <span :class="!activation.status.isError || 'text-danger'">
                                        {{ activation.status.string }}

                                        <v-tooltip top v-if="!activation.isCompleted && activation.status.message" :color="activation.status.isError ? 'error' : ''">
                                            <template v-slot:activator="{ on, attrs }">
                                                <i v-bind="attrs" v-on="on" class="fas fa-info-circle" :class="activation.status.isError ? 'text-danger' : 'text-info'"></i>
                                            </template>
                                            <span>
                                                {{ activation.status.message }}
                                            </span>
                                        </v-tooltip>
                                    </span>
                                </td>
                                <td v-if="activation.eids">
                                    <v-tooltip left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">{{ new Intl.NumberFormat().format(activation.eids) || '' }} {{ getIdentifierByPricingModel(activation.endpoint.pricing_model) }}s </span>
                                        </template>
                                        <span> Total Unique {{ getIdentifierPrefixByPricingModel(activation.endpoint.pricing_model) }} {{ getIdentifierByPricingModel(activation.endpoint.pricing_model) }}s </span>
                                    </v-tooltip>
                                </td>
                                <td v-else>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on"><i>N/A</i></span>
                                        </template>
                                        <span>Processing. Analytics aren't available.</span>
                                    </v-tooltip>
                                </td>

                                <td v-if="activation.eids">
                                    ${{ new Intl.NumberFormat().format(activation.eids * activation.costs) || '' }}
                                    <v-tooltip top v-if="activation.eids">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" small class="mt-n1 text-info">
                                                mdi-information-outline
                                            </v-icon>
                                        </template>
                                        <span>
                                            {{ new Intl.NumberFormat().format(activation.eids) }} {{ getIdentifierByPricingModel(activation.endpoint.pricing_model) }}s * ${{ activation.costs }} = ${{ new Intl.NumberFormat().format(activation.eids * activation.costs) }} <br />
                                            {{ activation.endpoint.pricing_model }}
                                        </span>
                                    </v-tooltip>
                                </td>
                                <td v-else>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on"><i>N/A</i></span>
                                        </template>
                                        <span>Processing. Costs aren't available.</span>
                                    </v-tooltip>
                                </td>

                                <td>{{ activation.user_id || '' }}</td>
                                <td>{{ activation.updated_at || '' }}</td>
                                <td>{{ activation.created_at || '' }}</td>
                                <td class="btn-td">

                                    <div class="btn-group" role="group" aria-label="User Actions">

                                        <div class="btn-group" role="group"
                                             v-if="(((activation.dataStreams.includes('Visitation') || activation.dataStreams.includes('Visitation Summary')) && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-visitation-summary'))
                                                || (activation.dataStreams.includes('Visitation Details') && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-visitation-details'))
                                                || (activation.dataStreams.includes('Origin') && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-origin'))
                                                || (activation.dataStreams.includes('Dwell Time') && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-dwell-time'))
                                                || (activation.dataStreams.includes('Network Analysis') && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-network-analysis'))
                                                || (activation.dataStreams.includes('Apps Report') && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-apps-report'))
                                                || (activation.dataStreams.includes('Demographics') && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-demographics')))
                                                && activation.isCompleted"
                                        >
                                            <button id="userActions" type="button" class="btn btn-primary text-white dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="fas fa-stream"></i>
                                            </button>

                                            <div class="dropdown-menu" aria-labelledby="userActions">
                                                <a class="dropdown-item"
                                                   v-if="activation.isCompleted && ((activation.dataStreams.includes('Visitation') || activation.dataStreams.includes('Visitation Summary')) && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-visitation-summary'))"
                                                   @click="redirectToDataStream('visitation-summary', activation)"
                                                >Visitation Summary</a>
                                                <a class="dropdown-item"
                                                   v-if="activation.isCompleted && (activation.dataStreams.includes('Visitation Details') && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-visitation-details'))"
                                                   @click="redirectToDataStream('visitation-details', activation)"
                                                >Visitation Details</a>
                                                <a class="dropdown-item"
                                                   v-if="activation.isCompleted && (activation.dataStreams.includes('Origin') && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-origin'))"
                                                   @click="redirectToDataStream('origin', activation)"
                                                >Origin</a>
                                                <a class="dropdown-item"
                                                   v-if="activation.isCompleted && (activation.dataStreams.includes('Dwell Time') && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-dwell-time'))"
                                                   @click="redirectToDataStream('dwell-time', activation)"
                                                >Dwell Time</a>
                                                <a class="dropdown-item"
                                                   v-if="activation.isCompleted && (activation.dataStreams.includes('Network Analysis') && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-network-analysis'))"
                                                   @click="redirectToDataStream('network-analysis', activation)"
                                                >Network Analysis</a>
                                                <a class="dropdown-item"
                                                   v-if="activation.isCompleted && (activation.dataStreams.includes('Apps Report') && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-apps-report'))"
                                                   @click="redirectToDataStream('apps-report', activation)"
                                                >Apps Report</a>
                                                <a class="dropdown-item"
                                                   v-if="activation.isCompleted && (activation.dataStreams.includes('Demographics') && $store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-demographics'))"
                                                   @click="redirectToDataStream('demographics', activation)"
                                                >Demographics</a>
                                            </div>
                                        </div>

                                        <v-tooltip
                                            v-else
                                            top color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :class="{'dropdown-corner-radius': isDataStreamsAvailable(activation)}"
                                                    id="userActions" type="button" class="btn btn-secondary" readonly>
                                                    <i class="fas fa-stream"></i>
                                                </button>
                                            </template>
                                            <span>Not Available</span>
                                        </v-tooltip>

                                        <v-tooltip top color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    depressed
                                                    color="info"
                                                    class="btn btn-info"
                                                    :class="{'dropdown-corner-radius': !isDataStreamsAvailable(activation)}"
                                                    @click="showItem(activation)"
                                                >
                                                    <i class="fas fa-eye"></i>
                                                </v-btn>
                                            </template>
                                            <span>View Activation</span>
                                        </v-tooltip>

                                        <v-tooltip top color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="showDeleteModal(activation)"
                                                    class="btn btn-danger">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </template>
                                            <span>Delete Activation</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <v-pagination
                            color="#ff7516"
                            v-if="totalPages > 1"
                            v-model="currentPage"
                            :length="totalPages"
                            :total-visible="7"
                        ></v-pagination>

                    </div>
                </v-app>
            </template>
        </Main>

        <ShowActivationItem v-if="showItemDialog"></ShowActivationItem>
        <DeleteModal v-if="deleteModalDialog"></DeleteModal>
    </div>
</template>

<script>
import Main from '../../components/Main'
import ShowActivationItem from '../../components/analyses/ShowActivationItem'
import api from "../../api/analyses/activations";
import DeleteModal from "../../components/general/DeleteModal";
import mixins from "../../mixin";
import TableLoading from "../../components/general/TableLoading";
import ResultsUrl from "../../components/analyses/partials/shared/ResultsUrl.vue";

export default {
    name: "ActivationDashboard",
    mixins: [mixins],
    data: () => ({
        filter: false,
        currentPage: 1,
        totalPages: 1,
        startDateMenu: false,
        endDateMenu: false,
        totals: {
            eids: 0,
            price: 0,
        },

        search: {
            q: '',
            sortBy: 'created_at',
            orderBy: 'desc',
            itemsPerPage: 25,
            createdBy: 'company',
            loading: false,
            startDate: '',
            endDate: '',
        },

        sorts: [
            {
                value: 'description',
                text: 'Name'
            },
            {
                value: 'status',
                text: 'Status'
            },
            {
                value: 'created_at',
                text: 'Last Created'
            },
            {
                value: 'updated_at',
                text: 'Last Updated'
            },
        ],

        loading: true,
        deleteModalDialog: false,
        activations: [],
        activation: [],
        showItemDialog: false,
        deletingActivation: [],
    }),
    components: {
        ResultsUrl,
        TableLoading,
        DeleteModal,
        Main,
        ShowActivationItem
    },
    methods: {
        showDeleteModal(activation) {
            this.deletingActivation = activation
            this.deleteModalDialog = true
        },
        async deleteItem() {
            await api.deleteActivation({
                activation: this.deletingActivation.id,
                _token: $('meta[name="_token"]').attr('content')
            })
            .then(res => {
                this.$toast.open({
                    message: 'Activation was successfully removed!',
                    type: "success",
                })
                this.deleteModalDialog = false
                this.deletingActivation = []
                this.fetchData()
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
                this.deleteModalDialog = false
                this.deletingActivation = []
            })
        },
        showItem(activation) {
            this.activation = activation.id
            this.showItemDialog = true
            if ((window.location !== window.location + '/item/' + activation.id + '/show') && (window.location.href.split('/').slice(-1)[0] !== 'show')) {
                window.history.pushState({}, null, window.location + '/item/' + activation.id + '/show');
            }
        },
        async fetchData() {
            await api.getAllActivations({
                page: this.currentPage,
                total: this.search.itemsPerPage,
                q: this.search.q,
                sortBy: this.search.sortBy,
                orderBy: this.search.orderBy,
                createdBy: this.search.createdBy,
                startDate: this.search.startDate,
                endDate: this.search.endDate,
            })
            .then(res => {
                this.activations = res.data.data
                this.currentPage = res.data.pagination.current_page
                this.totalPages = res.data.pagination.last_page
                this.totals.eids = res.data.totals.total_eids
                this.totals.price = res.data.totals.total_price
                this.loading = false
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
            })
        },
        filterData: _.debounce(function() {
            this.fetchData()
            this.search.loading = false
        }, 800),
        fetchActivationById: _.debounce(function (id) {
            this.showItem({'id': id})
        }, 800),
        redirectToDataStream(dataStream, activation) {
            let encoded_name = encodeURIComponent(activation.description)
            let base_url = this.data_streams_url

            if (dataStream === 'demographics') {
                let splitted_url = base_url.split("/")
                splitted_url = splitted_url.slice(0, -1)
                base_url = splitted_url.join("/")
            }

            window.location.href = base_url + `/${dataStream}?ActivationId=${activation.id}&ActivationName=${encoded_name}`
        },
        isDataStreamsAvailable(activation) {
            return !!((this.$store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-visitation-summary'))
                || (this.$store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-visitation-details'))
                || (this.$store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-origin'))
                || (this.$store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-dwell-time'))
                || (this.$store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-network-analysis'))
                || (this.$store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-datastreams-apps-report'))
                || (this.$store.getters.getUserPermissions.includes('frontend-data-explorer-visualization-demographics'))
                && ((activation.isCompleted && !!activation.dataStreams.length) || !activation.isCompleted && activation.dataStreams.length));
        }
    },
    created() {
        let firstDate = new Date(new Date().getFullYear(), 0, 1);
        let secondDate = new Date();

        if (secondDate.getMonth() < 3) {
            this.search.startDate = firstDate.getFullYear() -1 + '-' + ("0" + (firstDate.getMonth() + 1)).slice(-2) + '-' + ("0" + firstDate.getDate()).slice(-2);

        } else {
            this.search.startDate = firstDate.getFullYear() + '-' + ("0" + (firstDate.getMonth() + 1)).slice(-2) + '-' + ("0" + firstDate.getDate()).slice(-2);
        }
        this.search.endDate = secondDate.getUTCFullYear() + '-' + ("0" + (secondDate.getUTCMonth() + 1)).slice(-2) + '-' + ("0" + secondDate.getUTCDate()).slice(-2);

        this.fetchData()
        let id = window.location.href.split('/').slice(-2)[0]
        if (!isNaN(id)) {
            this.fetchActivationById(id)
        }
    },
    watch: {
        '$store.getters.getCompanyId' : function (val) {
            if (val !== null) {
                window.Echo.private('activations-' + this.$store.getters.getCompanyId)
                    .listen('Backend\\Activation\\ActivationUpdated', (e) => {
                        this.fetchData()
                    })
            }
        },
        currentPage: function () {
            this.fetchData()
        },
        'search.q': function () {
            if (this.search.q == null) {
                this.search.q = ""
            }
            this.filterData()
        },
        'search.sortBy': function () {
            this.search.loading = true
            this.filterData()
        },
        'search.orderBy': function () {
            this.search.loading = true
            this.filterData()
        },
        'search.itemsPerPage': function () {
            this.search.loading = true
            this.filterData()
        },
        'search.createdBy': function () {
            this.search.loading = true
            this.filterData()
        },
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
::v-deep .v-application--wrap {
        min-height: fit-content;
    }

button:focus {
    outline:0;
}

.dropdown-corner-radius {
    border-radius: 0.25rem 0 0 0.25rem !important;
}

.info-data {
    border: 2px solid #fb7e42;
    border-radius: 5px;
    color: #fb7e42;
    font-size: 1.25rem;
    font-weight: bold;
}

.info-label {
    color: #fb7e42;
}

</style>